/* Guard customer actions, without blocking Shopify's CAPTCHA continuation. */
(() => {
  if (window.pyContactSubmitGuard) return;
  window.pyContactSubmitGuard = true;

  const selector = '[data-py-contact-submit]';
  const pending = new Map();

  function reset(form) {
    const state = pending.get(form);
    if (!state) return;
    clearTimeout(state.timer);
    state.button.disabled = false;
    state.button.textContent = state.label;
    state.button.removeAttribute('aria-disabled');
    form.removeAttribute('aria-busy');
    pending.delete(form);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const button = form.querySelector(selector);
    if (!button || pending.has(form)) return;
    // Native validation runs before submit. Do not prevent this event or
    // a later programmatic submit: CAPTCHA may need both to complete.
    const state = { button, label: button.textContent };
    pending.set(form, state);
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.sendingLabel || 'Sending…';
    form.setAttribute('aria-busy', 'true');
    // Recover if navigation/CAPTCHA is cancelled or the connection stalls.
    state.timer = setTimeout(() => reset(form), 30000);
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(selector);
    if (!button || !pending.has(button.form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.isComposing) return;
    const target = event.target;
    if (target.tagName === 'TEXTAREA' || target.isContentEditable) return;
    if (!pending.has(target.form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  window.addEventListener('pageshow', () => {
    for (const form of pending.keys()) reset(form);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    for (const form of pending.keys()) {
      if (event.target.contains(form)) reset(form);
    }
  });
})();
